<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 shape-primary alpha-4">
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
      <span/>
    </div>
    <div class="container container-lg p-5">
      <card shadow>
        <div class="search-noresults">
          <section class="normal markdown-section">
            <div>
              <h4>1.使用外区账号登录App Store</h4>
              <p>1.1.公益共享苹果账号获取：</p>
              <ul>
                <li><a href="https://free.iosapp.icu">https://free.iosapp.icu</a></li>
                <li><a href="https://idfree.top">https://idfree.top</a></li>
                <li><a href="https://apple.laogoubi.net/s/c7d1e73290a646f2513f6f0b75843b0b">https://apple.laogoubi.net/s/c7d1e73290a646f2513f6f0b75843b0b</a></li>
                <li><a href="https://idshare.me">https://idshare.me</a></li>
                <li><a href="https://www.fengche666.xyz/p/appleid1">https://www.fengche666.xyz/p/appleid1</a></li>
                <li><a href="https://appleid.iossid.com">https://appleid.iossid.com</a></li>
                <li><a href="https://aunlock.laogoubi.net/s/df4ab9de842ce5f0abefcc560cf504f0">https://aunlock.laogoubi.net/s/df4ab9de842ce5f0abefcc560cf504f0</a></li>
                <li><a href="https://aunlock.laogoubi.net/s/1ddec87e5432ed7d6fb11056bc53fd6a">https://aunlock.laogoubi.net/s/1ddec87e5432ed7d6fb11056bc53fd6a</a></li>
              </ul>
              <!-- <h4>如共享账号无法使用，建议自行购买外区 <em>带有Shadowrocket的账号</em>，以后可以自己永久使用：本站推荐商家：<a href="https://fruit.vt1.work" target="_blank">水果商店</a>和<a href="https://xiaohuojian8.com/aff/2539.html" target="_blank">小火箭吧</a>（稳定可靠，价格实惠）</h4> -->
              <!-- <details>
                <summary>点击查看其他外区帐号和Shadowrocket兑换</summary>
                外区apple id、软件兑换码、礼品卡购买：<a href="https://googlevoice.top" target="_blank">神马杂货铺</a>，<a href="https://shuiguo.fcid.cc/" target="_blank">水果商店</a>（注明：推荐商家与本站无任何关系，购买过程中出现问题及时与商家联系）
              </details> -->
              <hr>
              <h4>2.下载Sing-Box：</h4>
              <p><a href="https://apps.apple.com/us/app/sing-box/id6451272673">https://apps.apple.com/us/app/sing-box/id6451272673</a></p>
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf1.webp" width="250">
              <hr>
              <h4>3.设置Sing-box：</h4>
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf2.webp" width="250">
              <hr>
              <h4>4.点击下面按钮 “点我导入到Singbox”，如果导入失败，请手动配置，然后按下图设置：</h4>
              <div v-if="accounts.length">
                <div v-for="account in accounts" :key="account._id" class="sub-item mb-2">
                  <div class="display-6 mt-2 mb-2">{{ account.product.title }}</div>
                  <a class="btn-sm mb-2 btn btn-primary" :href="`sing-box://import-remote-profile?url=https://www.sstz.info/v1/api/clash/${account.subscription || account._id }?#${account.product.title}`"><i class="fa fa-share"></i>点我导入到Singbox</a>
                  <base-button class="mb-2 mr-3" size="sm" type="primary" @click="handleCopy(`https://www.sstz.info/v1/api/clash/${account.subscription || account._id }?#${account.product.title}`, $event)" >复制订阅地址1</base-button>
                  <base-button class="mb-2 mr-3" size="sm" type="primary" @click="handleCopy(`https://www.lles.me/v1/api/clash/${account.subscription || account._id }?#${account.product.title}`, $event)" >复制订阅地址2</base-button>
                </div>
                <!-- 例子 v2rayng://install-config?url=http%3A%2F%2Fexample.com&name=example
  v2rayng://install-config?url 是固定，url=后面是订阅地址 -->
              </div>
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf4.webp" width="250">
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf5.webp" width="250">
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf6.webp" width="250">
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf7.webp" width="250">
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf8.webp" width="250">
              <hr>
              <h4>5.设置自动更新订阅：</h4>
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf9.webp" width="300">
              <img class="mr-2 sing-box" src="/img/client/ios/sing-box/sf10.webp" width="300">
            </div>
          </section>
        </div>
      </card>
    </div>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import clip from '@/utils/clipboard'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    accounts() {
      return this.$store.state.server.account
    },
    subLinks_1() {
      return this.$store.state.subLinks_1
    },
    subLinks_2() {
      return this.$store.state.subLinks_2
    }
  },
  mounted() {
    this.loading = true
    this.getAccounts().then(res => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions(['getAccounts']),
    handleCopy(text, event) {
      clip(text, event)
    }
  }

}
</script>
<style scoped>
.search-noresults td a{
  padding: 4px 0;
  line-height: 1.6;
}
.search-noresults img {
  max-width: 100%;
  vertical-align: top;
}
/* @media only screen and (min-width: 600px) {
 .search-noresults img {
    max-width: 100%;
  }
} */
@media only screen and (min-width: 768px) {
  .search-noresults img {
    max-width: 80%;
  }
}
</style>
